export default function Clear() {
    return {
        draw: ({ ctx, bounds }) => {
            ctx.clearRect(...bounds.params);
        },

        update: function(context) {
            if (context.tick % 30 === 0) {
                context.removeDead();
            }
        },
    };
}
